import Dialer2 from './pages/dialer2.vue';
import Voicemail from './pages/voicemail.vue'
import History from './pages/history.vue'
import Pref from './pages/preferences.vue'
import Conferences from './pages/conferences.vue'
import Conference from './pages/conference.vue'
import Chats from './pages/chats.vue'
import NewConference from './pages/newconference.vue'
import Authentication from './pages/authentication.vue';
import Queues from './pages/queues.vue';
import Dev from './pages/dev.vue';
import { Component } from 'vue';
import { RouteConfig } from 'vue-router';

const routes : RouteConfig[]= [];

// routes.push({ path: '/:faxNumber', name: 'upload', component: upload, props: true});
routes.push({ path: '/conferences', name: 'conferences', component: Conferences as any});
routes.push({ path: '/conference', name: 'conference', component: Conference as any});
routes.push({ path: '/conference/:confId', name: 'conference', component: Conference as any});
routes.push({ path: '/newconference', name: 'newconference', component: NewConference as any});
routes.push({ path: '/callhistory', name: 'callhistory', component: History as any});
routes.push({ path: '/voicemail', name: 'voicemail', component: Voicemail as any, props: true});
routes.push({ path: '/chats', name: 'chats', component: Chats as any, props: true});
routes.push({ path: '/prefs', name: 'prefs', component: Pref as any, props: true});
routes.push({ path: '/authentication', name: 'authentication', component: Authentication as any});
routes.push({ path: '/dialer', name: 'dialer', component: Dialer2 as any});
routes.push({ path: '/dialer2', name: 'dialer', component: Dialer2 as any});
routes.push({ path: '/queues', name: 'queues', component: Queues as any, props: true});

process.env.NODE_ENV !== 'production' && routes.push({ path: '/dev', name: 'dev', component: Dev as any, props: true });
routes.push({ path: '/:confId', name: 'default', component: Conference as any});

if (location.hostname === 'messages.rinble.com') {
  routes.push();
} else if (location.hostname == 'join.rinble.com') {
  routes.push({ path: '/', name: 'default', component: Conferences as any});
} else {
  routes.push({ path: '/', name: 'default', component: Dialer2 as any}); 
}

export {routes};